import React, { useRef } from 'react';
import { useEnteredView } from '@fiverr-private/hooks';
import { translate } from '@fiverr-private/i18n-react';
import { useRoleVariation } from '../../hooks/useRoleVariation';
import { translateRoleTitle } from '../../utils/translateRoleTitle';
import { useBI } from '../BIContext';
import { useSellerRole } from '../../hooks/useSellerRole';

interface RoleTabReporterProps {
    sellerRoleId?: string;
}

export const RoleTabReporter: React.FC<RoleTabReporterProps> = ({ sellerRoleId }) => {
    const observableRef = useRef<HTMLDivElement>(null);

    const sellerRole = useSellerRole(sellerRoleId);
    const roleVariation = useRoleVariation();

    const { reportRoleTabImpression } = useBI();

    useEnteredView(observableRef, {
        threshold: 1,
        onEntered: () => {
            const label = sellerRole
                ? translateRoleTitle(sellerRole, roleVariation[sellerRole.id])
                : translate('seller_page_perseus.professions_page.roles_tabs.overview');

            reportRoleTabImpression({ label });
        },
    });

    return <div ref={observableRef} />;
};
